import React from "react";

import "../../scss/molecules/_header-subfacet.scss";

class HeaderSubfacet extends React.Component {
  render() {
    return (
      <div
        className={
          "header-subfacet" +
          (this.props.className ? " " + this.props.className : "")
        }
      >
        <p className="header-subfacet-title">{this.props.title}</p>
        <p className="header-subfacet-value">{this.props.value}</p>
      </div>
    );
  }
}

export default HeaderSubfacet;
